module.exports = ":host ::ng-deep .ui-messages.ui-messages-info {\n  color: #021c4d; }\n\n.ineligiblebtn {\n  margin-top: 5px;\n  width: 30%; }\n\n@media (max-width: 855px) {\n  .ineligiblebtn {\n    width: 50%; } }\n\n@media (max-width: 480px) {\n  .ineligiblebtn {\n    width: 60%; } }\n\n@media (max-width: 400px) {\n  .ineligiblebtn {\n    width: 70%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admission/course-information/course-information.component.scss
// module id = ./src/app/admission/course-information/course-information.component.scss
// module chunks = main